var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgActionActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.893,
    height: 13,
    viewBox: "0 0 12.893 13",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "icon-action",
    d: "M8.176,2.064a.6.6,0,0,1,.541,0L14.558,5.01a.612.612,0,0,1,0,1.09L8.717,9.045a.6.6,0,0,1-.541,0L2.334,6.1a.612.612,0,0,1,0-1.09Zm-4.22,3.49L8.446,7.819l4.491-2.264L8.446,3.291ZM2.064,11.173a.6.6,0,0,1,.811-.273l5.572,2.809L14.018,10.9a.6.6,0,0,1,.811.273.612.612,0,0,1-.27.818L8.717,14.936a.6.6,0,0,1-.541,0L2.334,11.99A.612.612,0,0,1,2.064,11.173Zm.811-3.218a.6.6,0,0,0-.811.273.612.612,0,0,0,.27.818L8.176,11.99a.6.6,0,0,0,.541,0l5.842-2.945a.612.612,0,0,0,.27-.818.6.6,0,0,0-.811-.273L8.446,10.764Z",
    transform: "translate(-2 -2)",
    fill: "#888",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActionActive);
export default __webpack_public_path__ + "static/media/action-active.b104b9c928aa73fd6e09ec46a1bca457.svg";
export { ForwardRef as ReactComponent };